import Button from "@/components/core/Button/Button"
import DOMPurify from "isomorphic-dompurify"

const Confirmation = props => {
  const { staticText, resetData } = props

  return (
    <div className="customer-support__success-box">
      <h1 className="customer-support__success-message">
        {staticText?.messageHeaderSuccess}
      </h1>
      <div
        className="customer-support__success-description"
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(staticText?.messageDescriptionSuccess),
        }}
      />
      <div className="container">
        <Button
          customClass={"kf-react-button"}
          className={"kf-react-button button large black flexible"}
          role="button"
          id="submit-contact-form-button"
          onClick={resetData}
          type="black"
          label={staticText?.backToCustomerSupport}
        />
      </div>
    </div>
  )
}

export default Confirmation
